<template>
  <div class="indexHome">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="home">
      <div class="home_title">推荐</div>
      <div class="game_list_box">
        <!-- 每日推荐 -->
        <div v-if="todyaRecommend" @click="checkGameDes(todyaRecommend.gid)" class="game_item game_item_bg"
          :style="{ backgroundImage: `url(${todyaRecommend.template_img})` }">
          <div class="game_banner">
            <img :src="todyaRecommend.img_url" alt="">
          </div>
          <div class="game_mes">
            <div class="game_mes_lt">
              <div class="game_icon">
                <img :src="todyaRecommend.icon_url" alt="">
                <div class="game_icon_tips" v-for="(itemicon, indexes) in todyaRecommend.icon_check_box" :key="indexes">
                  <div v-if="itemicon === '0.1产品'" class="discount_icon">
                    <img src="@/assets/image/discount.png" alt="" />
                  </div>
                  <div v-if="itemicon === '加速'" class="speed_icon">
                    <img src="@/assets/image/speed.png" alt="" />
                  </div>
                  <div v-if="itemicon === '专服'" class="service_icon">
                    <img src="@/assets/image/specialized_service.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="game_des">
                <div class="game_name">{{ todyaRecommend.show_name || todyaRecommend.game_name }}</div>
                <div class="game_play">
                  <div v-html="formatting(todyaRecommend.ready_date, 5)" class="play_time">
                    <!-- 今天<span>11：00</span>上线 -->
                  </div>
                  <div v-if="formatting(todyaRecommend.ready_date, 5)" class="shu">|</div>
                  <div class="play_num">{{ todyaRecommend.player_count }} 人在玩</div>
                </div>
              </div>
            </div>
            <div class="game_mes_rt game_btn_bg">
              <img v-if="todyaRecommend.is_server_rebate" class="new_outfit" src="@/assets/image/new_serve_icon.png"
                alt="">
              <img class="free_edition_2" v-if="todyaRecommend.is_free == 1" src="@/assets/image/btn_icon7.png" alt="">
              <template v-else-if="todyaRecommend.discount_img_url2">
                <img class="free_edition_2" :src="todyaRecommend.discount_img_url2" alt="">
                <p class="discount" v-if="todyaRecommend.rebate_type == 2 && todyaRecommend.discount_img_url2">{{
                  todyaRecommend.first_rebate | getRoundedNumber }}</p>
              </template>
              <div v-else class="game_btn">{{ todyaRecommend.first_rebate | getRoundedNumber }}<span>折</span></div>
            </div>
          </div>
        </div>
        <!-- 游戏列表 -->
        <div v-for="(game, index) in recommend_games" @click="checkGameDes(game.gid)" class="game_item"
          :key="'game_item' + game.gid">
          <div v-if="game.big_img_url" class="game_banner">
            <img :src="game.big_img_url" alt="">
          </div>
          <div class="game_mes">
            <div class="game_mes_lt">
              <div class="game_icon">
                <img :src="game.icon_url" alt="">
                <div class="game_icon_tips" v-for="(itemicon, indexes) in game.icon_check_box" :key="indexes">
                  <div v-if="itemicon === '0.1产品'" class="discount_icon">
                    <img src="@/assets/image/discount.png" alt="" />
                  </div>
                  <div v-if="itemicon === '加速'" class="speed_icon">
                    <img src="@/assets/image/speed.png" alt="" />
                  </div>
                  <div v-if="itemicon === '专服'" class="service_icon">
                    <img src="@/assets/image/specialized_service.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="game_des">
                <div class="game_name">{{ game.show_name || game.game_name }}</div>
                <div class="game_play">
                  <div class="play_time" v-html="formatting(game.ready_date, 4)">
                    <!-- 今天<span>11：00</span>上线 -->
                  </div>
                  <div v-if="formatting(game.ready_date, 4)" class="shu">|</div>
                  <div class="play_num">{{ game.player_count }} 人在玩</div>
                </div>
                <div class="game_tag">
                  <span v-for="itemGame in game.game_tags" :key="itemGame.id" class="tag_item">{{ itemGame.text
                    }}</span>
                </div>
              </div>
            </div>
            <!-- :class="game.discount_img_url === 0 ? '' : index === 1 ? 'game_btn_red_bg' : ''" -->
            <div class="game_mes_rt">
              <img class="new_outfit" v-if="game.is_server_rebate" src="@/assets/image/new_outfit_icon.png" alt="">
              <img class="free_edition_2" v-if="game.is_free == 1" src="@/assets/image/btn_icon2.png" alt="">
              <template v-else-if="game.discount_img_url">
                <img class="free_edition_2" :src="game.discount_img_url" alt="">
                <p class="discount" v-if="game.rebate_type == 2 && game.discount_img_url">{{ game.first_rebate |
                  getRoundedNumber }}</p>
              </template>
              <div v-else class="game_btn">{{ game.first_rebate | getRoundedNumber }}<span>折</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { postData } from '@/api/api.js'
import formatTime from "@/filters/index.js";
// import Loading from '../util/loading.js'

export default {
  name: 'indexHome',
  components: {
    // HelloWorld
  },
  data() {
    return {
      recommend_games: [],
      // 今日推荐
      todyaRecommend: []
    }
  },
  mounted() {
    let that = this
    this.fetchData(that)
  },
  methods: {
    async fetchData(that) {
      this.$loadinges.show('.home');
      const endpoint = '/box/tabs'
      const params = {
        tab: 0,
        subchannelnum: 0
      }
      const res = await postData(endpoint, params)
      if (res?.code === 0) {
        this.$loadinges.hide()
        // 大icon
        this.todyaRecommend = res.data.big_icon
        this.getRecommendGames(res.data.big_icon)
        // this.recommend_games = res.data.small_icons.filter(item => item.gid !== res.data.big_icon.gid)
      }
    },
    async getRecommendGames(list) {
      this.$loadinges.show('.home');
      const endpoint = '/box/tabs/small-icon'
      const params = {
        tab: 0,
        subchannelnum: 0,
        page: 0
      }
      const res = await postData(endpoint, params)
      if (res?.code === 0) {
        this.$loadinges.hide()
        // 大icon
        this.recommend_games = res.data?.filter(item => item.gid !== list?.gid)
      }
    },
    formatting(time, type = 0) {
      return formatTime.formatTime9(time, type)
    },
    checkGameDes(id) {
      this.$router.push({
        path: "/gameDetail",
        query: {
          id: id,
        },
      });
    }
  },
}
</script>

<style lang="less" scoped>
.indexHome {
  width: 100%;
  padding: 0 36px;
  box-sizing: border-box;
}

.home {
  box-sizing: border-box;
  position: relative;

  .home_title {
    font-size: 18px;
    font-weight: 700;
    text-align: left;
    margin-bottom: 10px;
  }

  .game_list_box {

    .game_item {
      width: 100%;
      // height: 536px;
      margin-bottom: 24px;
    }

    // game_item公共样式
    .game_banner {
      width: 100%;
      // height: 337px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 20px 20px 0 0;
      }
    }

    .game_mes {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 15px;

      .game_mes_lt {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .game_icon {
          position: relative;

          >img {
            width: 115px;
            height: 115px;
            border-radius: 20px;
          }

          .game_icon_tips {
            position: absolute;
            top: 0;
            left: 0;
            width: 116px;
            height: 116px;

            >div {
              width: 116px;
              height: 116px;

              >img {
                width: 116px;
                height: 116px;
              }
            }
          }
        }

        .game_des {
          margin-left: 15px;

          .game_name {
            text-align: left;
            // margin-bottom: 5px;
            font-size: 24px;
            font-weight: 500;
            max-width: 330px;
            white-space: nowrap;
            /* 防止文本换行 */
            overflow: hidden;
            /* 隐藏溢出的文本 */
            text-overflow: ellipsis;
            /* 在溢出文本的位置显示省略号 */
          }

          .game_play {
            display: flex;
            align-items: center;
            margin: 5px 0 7px;
            color: rgba(0, 0, 0, .4);

            .play_time {
              ::v-deep span {
                margin: 0 5px;
                color: #FF3838;
              }
            }

            .play_num {
              margin-right: 5px;
            }

            .shu {
              display: inline-block;
              margin: 2px 7px 0;
              vertical-align: top;
            }
          }
        }
      }

      .game_mes_rt {
        position: relative;

        .new_outfit {
          position: absolute;
          top: -8.5px;
          left: 50%;
          transform: translate(-50%, 0);
          width: 40px;
          height: 17px;
        }

        .game_btn {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          color: #ffffff;
          font-weight: 700;
          width: 65px;
          height: 32px;
          border-radius: 16px;
          background-color: #FF3838;

          >span {
            font-size: 14px;
          }
        }

        // 除去每日推荐--游戏0.1折按钮样式
        .discount {
          position: absolute;
          color: #FF3838;
          font-family: "DIN";
          font-size: 14px;
          font-weight: bold;
          top: 48%;
          left: 31%;
          transform: translate(-50%, -50%);
        }

        .free_edition_2 {
          width: 66px;
          height: 45px;
        }
      }
    }

    .game_tag {
      display: flex;

      .tag_item {
        display: inline-block;
        margin-right: 10px;
        background-color: #FEF3DE;
        color: #FF8000;
        font-size: 12px;
        border-radius: 5px;
        padding: 3px 10px;
        box-sizing: border-box;
      }
    }

    // 每日推荐--折扣0.1按钮样式
    .game_btn_bg {
      position: relative;

      .game_btn {
        width: 65px !important;
        height: 42px !important;
        justify-content: space-around !important;
        padding: 0 2px;
        background-image: url('@/assets/image/no_bt.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-color: transparent !important;
      }

      .discount {
        position: absolute !important;
        color: #ffffff !important;
        font-family: "DIN" !important;
        font-size: 14px !important;
        font-weight: bold !important;
        top: 48% !important;
        left: 31% !important;
        transform: translate(-50%, -50%) !important;
      }

      // .free_edition_2 {
      //   width: 66px;
      //   height: 45px;
      // }
    }

    // 0.1折按钮样式
    // .game_btn_red_bg {
    //   .game_btn {
    //     width: 65px !important;
    //     height: 32px !important;
    //     justify-content: space-around !important;
    //     color: #FF3838 !important;
    //     padding: 0 2px;
    //     background-image: url('@/assets/image/bt_icon.png');
    //     background-size: 100% 100%;
    //     background-repeat: no-repeat;
    //     background-color: transparent !important;

    //     span {
    //       color: #ffffff;
    //     }
    //   }
    // }

    // 每日推荐特殊样式
    .game_item_bg {
      padding: 50px 16.5px 16.5px;
      background-image: url('@/assets/image/game_bg.png');
      background-repeat: no-repeat;
      background-size: cover;
      box-sizing: border-box;

      .game_banner {
        width: 100%;
        height: 378px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 20px;
        }
      }

      .game_mes {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .game_mes_lt {
          .game_icon {
            width: 105px;
            height: 105px;
            position: relative;
            margin-top: -30px;

            >img {
              position: absolute;
              top: -15px;
              left: 0;
              width: 105px;
              height: 105px;
              border-radius: 20px;
            }

            .game_icon_tips {
              position: absolute;
              top: -15px;
              left: 0;
              width: 106px;
              height: 105px;

              >div {
                width: 106px;
                height: 106px;

                >img {
                  width: 106px;
                  height: 106px;
                }
              }
            }
          }

          .game_des {

            .game_name {
              margin-bottom: 5px;
              font-size: 24px;
              font-weight: 500;
              color: #ffffff;
            }

            .game_play {
              display: flex;
              align-items: center;
              font-size: 14px;
              margin: 0 0 10px 0;
              color: #ffffff;

              .shu {
                margin: -2px 7px 0;
                vertical-align: top;
              }

              span {
                color: #ffffff !important;
              }
            }
          }
        }
      }
    }

  }
}
</style>
